import { ReorderIcon } from "web/components/Icon"
import { DeleteIconButton } from "web/components/IconButton"
import { ValueView } from "web/components"
import { getSummaryMethodLabel } from "../Tiles/SummaryTiles/util"
import { SelectMenu } from "web/components"

const presentationOptions = [
  {
    value: "value",
    label: "Value",
  },
  {
    value: "value_percentage",
    label: "Value (%)",
  },
  {
    value: "percentage",
    label: "%",
  },
]

export default function FieldListItem({
  label,
  fieldId,
  handleDeleteField,
  presentation,
  presentations,
  changeFieldPresentation,
}) {
  function handlePresentationChange(presentationValue) {
    changeFieldPresentation(fieldId, presentationValue.value)
  }

  const selectedValue = presentationOptions.find(
    (o) => o.value === presentation
  )

  return (
    <div className="flex cursor-move items-center gap-x-2.5 rounded-md border px-2.5 py-1 text-sm shadow-sm">
      <ReorderIcon />
      <div className="flex-auto font-medium">{label}</div>
      {presentations.length > 1 && (
        <div className="h-6 w-24 rounded-md border bg-slate-100 py-0 text-xs">
          <SelectMenu
            selectedValue={selectedValue}
            handleSelectChange={handlePresentationChange}
            options={presentationOptions}
            placeholder="Select"
          />
        </div>
      )}
      <DeleteIconButton onClick={handleDeleteField} />
    </div>
  )
}

export function getDisplayValue(data, fieldKey) {
  if (!data || !data.values || !data.values[fieldKey]) {
    return null
  } else {
    const dataValue = data.values[fieldKey]
    if (dataValue && dataValue.hasOwnProperty("value")) {
      return dataValue
    } else {
      return { value: dataValue }
    }
  }
}

export function FieldListItemWithValue({
  summaryMethod,
  value,
  label,
  fieldKey,
  summaryMessage,
  has_more_info = false,
  handleDeleteField,
  showDummyData,
}) {
  return (
    <div className="my-2 grid w-full cursor-move grid-cols-12 gap-2 rounded-md bg-white p-2 text-sm shadow">
      <span className="col-span-1 self-center">
        <ReorderIcon />
      </span>
      <span className="col-span-3 self-center font-medium">{label}</span>
      <span className="col-span-4 self-center">
        <ValueView
          fieldKey={fieldKey}
          has_more_info={has_more_info}
          inert={showDummyData}
          {...value}
        />
      </span>
      <span className="col-span-3 flex self-center font-medium">
        {summaryMessage
          ? summaryMessage
          : getSummaryMethodLabel(summaryMethod, true)}
      </span>
      <span className="col-span-1 flex justify-self-end">
        <span className="self-center">
          <DeleteIconButton onClick={handleDeleteField} />
        </span>
      </span>
    </div>
  )
}
